<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.programs(v-if='!loading')
        .grid
          .col-12
            h1.h-l.category
              | programs
          .col-12
            .screen(v-if='!loading')
              router-link(:to="{name: 'programs-page', params: {category: category(featured.content.category), id: featured.uid }}")
                .hero
                  img.cover(:src="featured.main_image.url" alt="CAAM Programs")
                .captions.gradient
                  h2.h-xl
                    | {{ featured.title }}
                  h2.h-l
                    | {{ featured.content.date }}
                  h2.h-l
                    | {{ featured.content.start_time }} - {{ featured.content.end_time }}
          .col-4_xs-12.titles
            h2.h-l
              | calendar
            //- datepicker.picker.noselect(
            //-   :config="{ wrap: true, static: true, onChange: update, animate: false, minDate: 'today'}"
            //-   placeholder="select a date"
            //-   v-model="dateSelected"
            //- )
            //-   p.body.bold(@click="openCalendar")
            //-     | select a date
            //-   a.input-button.x(title="toggle" data-toggle)
            //-     figure
            //-       img(src="/static/icons/x_out_white.svg")
          .col-8_xs-12.week#calendarcontainer
            .grid.no-margin
              .col-8
                h2.h-l
                  | {{ day }}
              .col-8(v-for="program in week" v-if="week.length > 0")
                router-link.dateTime(
                  :to="{name: 'programs-page', params: {category: category(program.content.category), id: program.uid }}"
                )
                  h3.h-m
                    | {{ program.content.title }}
                  h4.h-sm
                    | {{ program.content.date }}
                  p.h-sxx
                    | {{ program.content.start_time }} - {{ program.content.end_time }}
              .col-8(v-if="week.length === 0")
                h4.h-l
                  | No events scheduled for this day.
              .col-8
                .pmargin
              .col-6_xs-12(v-for="item in children")
                .filter
                  .captions-mobile
                    h2.h-l.subpage
                      | {{ item.content.title.toLowerCase() }}
                  .screen-smaller(v-if='!loading')
                    router-link(:to="{name: 'programs-overview', params: {category: category(item.category)}}")
                      img.cover(:src="item.main_image.url")
                    .captions.gradient
                      h2.h-l.subpage
                        | {{ item.category.toLowerCase() }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import Datepicker from 'vue-bulma-datepicker'

export default {
  name: 'program',
  mixins: [DataMixin, ComponentMixin],
  components: {
    Datepicker
  },

  data () {
    return {
      date: new Date(),
      selectDate: false,
      dateSelected: '',
      day: 'next 30 days',
      url: 'https://staging.caamuseum.org/api/programs/day?date='
    }
  },

  created () {
    this.requestData('programs', 'programs')
  },

  methods: {
    category: function (item) {
      const str = item.split("'").join('-')
      const sanatize = (str.split(' ').join('-').toLowerCase()).split('!').join('')
      return sanatize.split(',').join('').toLowerCase()
    },

    openCalendar: function () {
      document.getElementsByClassName('flatpickr-input')[0].focus()
    },

    closeCalendar: function () {
      document.getElementsByClassName('flatpickr-input')[0].blur()
    },

    update: function () {
      this.getData()
    },

    getData: function () {
      const url = this.url + this.dateSelected
      this.loading = true
      this.get(url, response => {
        this.loading = false
        this.week.splice(0, this.week.length)
        this.day = response.data.day
        for (var i = 0; i < response.data.programs.length; i++) {
          this.week.push(response.data.programs[i])
        }
      })
    }
  },

  computed: {
    data: function () {
      return this.loadedData.programs
    },

    content: function () {
      return this.data.content
    },

    featured: function () {
      return this.data.featured
    },

    past: function () {
      return this.data.past
    },

    edu: function () {
      return this.data.education
    },

    week: function () {
      return this.data.week
    },

    children: function () {
      return this.data.children
    },

    key: function () {
      return 'programs'
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .programs
    margin-top: $paddingTop
    .pmargin
      height: 4rem
    .titles
      margin-top: 0
    h4
      margin: 0
    .category
      color: $programs
      margin-bottom: 2rem
    .screen
      height: 76.5vH
      width: 100%
      margin-bottom: 6rem
      position: relative
      @include respond-to(xs)
        height: 52vW !important
        margin-bottom: 0
      .hero
        width: 100%
        height: 76.5vH
        @include respond-to(xs)
          height: 52vW
      .captions
        position: absolute
        bottom: 0
        width: calc(100% - 3.81vw)
        color: #FFF
        padding: 20vh 0 3.81vw 3.81vw
        @include respond-to(xs)
          padding: 3.81vw
        &.gradient
          background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.9))
    .week
      position: relative
      h2, h3, h4, a
        padding: 0
        margin: 0
      h3
        padding-top: 0.4rem
      p
        padding-left: 0
        margin: 0
      a
        &:hover h3
          border-bottom: solid 2px #000
      h3
        display: inline
        border-bottom: solid 2px #FFF
      .dateTime
        h4, p
          margin: 0
    .filter
      margin: 0
      h2
        margin-bottom: 2rem
      .screen-smaller
        position: relative
        .captions, .captions-mobile
          width: 100%
          height: 40%
          opacity: 1
          color: white
          position: absolute
          bottom: 0
          pointer-events: none
          &.gradient
            background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
          h2
            position: absolute
            bottom: 0
            padding: 0 3.3rem 3.3rem 3.3rem
            margin: 0
        .captions
          @include respond-to(xs)
            display: none
      .captions-mobile
        display: none
        @include respond-to(xs)
          display: block
    .picker
      p
        color: #f47b1f
        cursor: pointer
      .x
        position: absolute
        cursor: pointer
        left: 21vW
        z-index: 99999999
        top: 79vH
        figure
          img
            width: 3rem
      input
        opacity: 0
        height: 0
        padding: 0
        margin: 0
    .flatpickr-rContainer
      width: 60%
      left: 20%
      top: 21rem
      position: relative
      .flatpickr-weekdays
        width: 100%
        letter-spacing: -0.1rem
      .flatpickr-days, .dayContainer
        width: 100% !important
        min-width: unset
        max-width: unset
        .dayContainer
          flex-direction: row
    .flatpickr-calendar
      border-radius: 0
      box-shadow: none
      position: relative
      top: -5rem !important
      left: 21vW
      width: 71.34vW
      height: 97vH
      background-color: rgba(0,0,0,0.9)
      &.open
        max-height: 97vH
      .flatpickr-innerContainer
        overflow: visible
      .flatpickr-current-month
        text-align: left
        left: 13.8%
        font-size: 4rem
        letter-spacing: -0.23rem
      .flatpickr-month
        height: 86vH
        width: 100%
        position: absolute
        top: 13vH
        color: white
        text-transform: lowercase
        .numInputWrapper
          font-family: inherit
          color: inherit
          margin-left: 2rem
          > *
            font-weight: 700
        .flatpickr-prev-month, .flatpickr-next-month
          position: absolute
          top: 32.5vH
          svg
            fill: #FFF
            width: 3vW
        .flatpickr-next-month
          right: 9vW
        .flatpickr-prev-month
          left: 9vW
      .flatpickr-weekday
        text-transform: lowercase
        color: white
        font-size: 1.7rem
        font-weight: 700
      .flatpickr-day
        box-sizing: unset
        color: white
        font-size: 1.7rem
        font-weight: 700
        flex-basis: 2.5vW
        margin: 1.5vW
        margin-bottom: 1vW
        max-width: 2.5  vW
        height: 2.5vW
        &.selected
          background-color: #68cce8
          border-color: #68cce8
        &.today
          background-color: #f47b1f
          border-color: #f47b1f
      .prevMonthDay, .nextMonthDay
        opacity: 0
        cursor: default
      &.animate.open
        animation: none
        -webkit-animation: none
</style>



// WEBPACK FOOTER //
// Programs.vue?9e9cbe6c